module.exports = __webpack_public_path__ + "static/media/carbon-flex.c737faff.png";